<template>
  <div id="app">
    <div id="cont">
      <header>
        <div class="logo">
          <img src="./assets/img/LogoApolo.png" draggable="false" />
        </div>
        <nav>
          <div class="items">
            <ul class="items-main_items">
              <li class="item item-pago">
                <button @click="redirectTo()">Ir a la página principal</button>
              </li>
            </ul>
          </div>
        </nav>
      </header>
      <div id="la_imagen">
          <img id="la_imagen_mobile" src="./assets/img/ImgnApoloFull.png" draggable="false">
          <img id="la_imagen_desck" src="./assets/img/ImgApolo.png" draggable="false">
      </div>
      <Pago></Pago>
    </div>
    <footer>
        <div class="footer-logo">
            <img src="./assets/img/LogoApoloFooter.png" alt="">
        </div>
        <div class="footer-cont">
            <div class="footer-cont1">
                <div><a href="#nav-home">Home</a></div>
                <div><a href="#nav-nosotros">Nosotros</a></div>
                <div><a href="#nav-servicios">Servicios</a></div>
            </div>
            <div></div>
            <div class="footer-cont2">
                <div class="email"><a href="#">contacto@apolo25.com</a></div>
                <div><a href="#">55 3050 4762</a></div>
                <div><a href="#">Blog</a></div>

            </div>
            <div class="footer-cont3">
                <div class="footer-cont3-socialnetwork">
                    <hr>
                    <a href="https://www.facebook.com/gapolo25/ " target="_blank"><img src="./assets/img/facebook2x.png"
                            alt=""></a>
                    <a href="https://www.instagram.com/apolo25agencia" target="_blank"><img
                            src="./assets/img/instagram2x.png" alt=""></a>
                    <a href="https://www.behance.net/apolo25 " target="_blank"><img src="./assets/img/behance2x.png"
                            alt=""></a>
                    <a href="https://mx.linkedin.com" target="_blank"><img src="./assets/img/lnk2x.png" alt=""></a>
                </div>
            </div>
        </div>
    </footer>
  </div>
</template>

<script>
import Pago from "./components/Pago.vue";

export default {
  name: "App",
  components: {
    Pago,
  },
  methods: {
    redirectTo(){
     window.location="https://apolo25.com";
    }
  }
};
</script>

<style>
*{
  margin: 0;
  scrollbar-width: thin;          /* "auto" or "thin" */
  scrollbar-color: #FA4B1F #1D1D1B;
}
::-webkit-scrollbar {
    width: 12px;
}
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    border-radius: 10px;
    background-color: #1D1D1B;
}
::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    background-color: #FA4B1F;
}
body {
  margin: 0;
}
#app{
  background-color: #FC4D21;
}
#cont{
  position: relative;
  padding-bottom: 10vw;
}
header {
  background-color: #FC4D21;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  top: 0;
  z-index: 50;
  position: sticky;
  box-shadow: 0 1px 20px 0 rgb(31 38 135 / 37%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(4px);
}
#la_imagen{
  position: absolute;
  width: 48VW;
  bottom: 0;
  left: 0;
}
#la_imagen_mobile{
  display: none;
}
#la_imagen img{
  width: 100%;
}
.logo {
  width: 10vw;
  margin: 1% 0% 1% 4%;
}
.logo img {
  width: 100%;
}
nav {
  margin-right: 4%;
  width: 40%;
}
.items-main_items {
  list-style-type: none;
}
.items-main_items {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0%;
}
.item-pago button {
  font-family: "Montserrat", sans-serif;
  background-color: #f8d2b9;
  color: #FC4D21;
  border: #FC4D21 solid 1px;
  border-radius: 2px;
  padding: 5px 2rem;
  cursor: pointer;
}
footer{
    background-color: #1D1D1B;
    padding: 2% 7%;
}
.footer-logo{
    padding: 0% 0% 2%;
}
.footer-cont{
    display: grid;
    grid-template-columns: 10% 0% 10% 25%;
    justify-content: space-between;
    height: 25vh;
}
.footer-cont a{
    text-decoration: none;
    color: #F9F5DE;
    font-size: 1.4vw;
    font-family: 'Mulish', sans-serif;
}
.footer-cont a:hover{
    text-decoration: underline;
}
.email a{
    color: #FC4D21;
}
.footer-cont1, .footer-cont2{
    display: grid;
    grid-template-rows: 30% 30% 30%;
}
.footer-cont3{
    padding: 1%;
}
.footer-cont3-socialnetwork{
    position: relative;
    display: flex;
    justify-content: space-around;
    border: 2px solid #F9F5DE;
    border-radius: 7px;
    padding: 5%;
    width: 100%;
}
.footer-cont3-socialnetwork hr{
    position: absolute;
    top: 50%;
    left: -101vw;
    width: 100.9vw;
    color: #F9F5DE;
}
.footer-cont3-socialnetwork img{
    width: 50%;
}
.footer-cont3-socialnetwork img:hover{
    cursor: pointer;
}

@media (max-width: 500px) {
  .logo {
    width: 25%;
  }
  nav {
    width: 50%;
  }
  #la_imagen_mobile{
    display: flex;
    width: 100%
  }
  #la_imagen_desck{
    display: none;
  }
  #la_imagen {
    top: 14VW;
    left: 0;
    right: 0;
    margin: auto;
    width: 55vw;
  }
  .item-pago button {
    font-size: 3vw;
  }
  .footer-logo {
        text-align: center;
        padding: 0% 0% 7%;
    }
    .footer-cont {
        grid-template-columns: 10% 0% 10% 25%;
        justify-content: space-between;
        height: 150px;
    }
    .footer-cont a {
        font-size: 4.4vw;
    }
    .footer-cont1, .footer-cont2 {
        grid-template-rows: 20% 20% 20%;
    }
    .footer-cont3{
        position: relative;
    }
    .footer-cont3-socialnetwork{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 200%;
    }
}
</style>
